import { createContext, useContext } from 'react';

import { type DetailsContextState } from '../types';

const DetailsContext = createContext<Nullable<DetailsContextState>>(null);

const useDetailsContext = () => {
  const context = useContext(DetailsContext);
  if (!context) {
    throw new Error('useDetailsContext must be used within a DetailsProvider');
  }
  return context;
};

export { DetailsContext, useDetailsContext };
